import { useEffect, useState } from 'react';
import { FilterPill, VisuallyHidden } from '../../connections/ConnectionScope';
import { Dropdown, Menu, MenuItem, SearchBox } from '../MergeRulesScope';
import { getTenantDisplayLabel } from '../../../shared-components/app-personas/AppPersona.selectors.redux';

const DropdownFilter = ({ label, values, children }: any) => (
  <Dropdown>
    <FilterPill slot="trigger" values={values} caret>
      {label}
    </FilterPill>
    {children}
  </Dropdown>
);

export const FilterComponent = (props:any) => {
  
  const [searchText, setSearchText] = useState('');
  const data = props.allData;
  const handleSearch = (e: any) => {
    setSearchText(e.target.value);
};

useEffect(()=>{
  const appliedFilter = (searchText?searchText:'').trim()?.toLowerCase();
  var newFilteredObj = Object.assign({});

  data.forEach((key: string) => {
    if (key && key.toLowerCase().includes(`${appliedFilter}`)) {
      newFilteredObj[key] = props.checkedState[key];
    }
  });
  props.setCheckedState(newFilteredObj);

}, [searchText])

  const handleChange = ({ target }:any) => {
    // Use data-key attribute to get the actual key, fallback to textContent for non-tenant filters
    const key = target.getAttribute('data-key') || target.textContent;
    props.setCheckedState({ ...props.checkedState, [key]: target.checked });
  };

  // Map tenant keys to display labels for the filter pill display
  const getDisplayValues = () => {
    const selectedKeys = Object.keys(props.checkedState).filter((key: string) => props.checkedState[key]);
    if (props.filterlabel === 'Tenant: ') {
      return selectedKeys.map(key => getTenantDisplayLabel(key));
    }
    return selectedKeys;
  };

  return (<>
     <DropdownFilter
      label={props.filterlabel}
      values={getDisplayValues()}
    >
     {props.searchBarVisible && <SearchBox style = {{padding:"8px"}} onInput={handleSearch} placeholder="Search"
            onHeClear={() => setSearchText("")}/>}
      <Menu>
        {Object.keys(props.checkedState).map(key => (
          <MenuItem
            key={key}
            data-key={key}
            role="menuitemcheckbox"
            checked={props.checkedState[key]}
            onHeChange={handleChange}
          >
            {props.filterlabel === 'Tenant: ' ? getTenantDisplayLabel(key) : key}
          </MenuItem>
        ))}
      </Menu>

    </DropdownFilter>
  </>
 
  );
};